
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.177 19H3.355c-.47 0-.854-.413-.854-.922v-6.863H.855c-.472 0-.855-.413-.855-.921V7.353c0-.508.383-.922.855-.922H2.5V4.96c0-1.46.425-2.703 1.23-3.593C4.537.472 5.666 0 6.994 0l2.152.004c.47 0 .853.414.853.921v2.73c0 .51-.383.922-.854.922l-1.45.001c-.441 0-.553.096-.578.125-.04.048-.086.186-.086.565V6.43h2.005c.15 0 .297.04.423.116.27.163.44.472.44.806l-.002 2.94c0 .509-.383.922-.854.922H7.032v6.863c0 .509-.384.922-.855.922zm-2.643-1.114h2.465v-7.17c0-.339.256-.615.57-.615h2.296l.001-2.556H6.57c-.314 0-.57-.276-.57-.615V5.268c0-.435.04-.93.345-1.302.368-.45.948-.502 1.353-.502h1.27V1.117l-1.973-.003c-2.134 0-3.46 1.473-3.46 3.845v1.97c0 .34-.256.616-.57.616H1.032v2.556h1.93c.315 0 .57.276.57.616v7.17z"}})])
          )
        }
      }
    